<template>
  <div class="accordions">
    <component
      :is="sectionComponent"
      v-for="(sectionComponent, index) in sectionComponents"
      :key="index"
      :section="section"
      @open-section="section = $event"
    />

    <div
      v-if="updated"
      class="save_btn"
    >
      <primary-button
        :class="[
          'update_btn',
          locationLoading ? 'disabled' : '',
        ]"
        size="md"
        @click="saveLocationChanges(location)"
      >
        {{ locationLoading ? 'Saving' : 'Save' }} changes
        <i
          v-if="locationLoading"
          class="fa fa-spinner fa-spin"
        />
      </primary-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProfilePictureCoverPhoto from "../sections/ProfilePictureCoverPhoto";
import BusinessName from "../sections/BusinessName";
import BusinessPhone from "../sections/BusinessPhone";
import BusinessAddress from "../sections/BusinessAddress";
import WebsiteUri from "../sections/WebsiteUri";
import LocationCategories from "../sections/LocationCategories";
import OpeningTimes from "../sections/OpeningTimes";
import LocationDescription from "../sections/LocationDescription";
import PrimaryButton from "../../../global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    LocationDescription,
    OpeningTimes,
    LocationCategories,
    WebsiteUri,
    BusinessAddress,
    BusinessPhone,
    BusinessName,
    ProfilePictureCoverPhoto
  },
  data() {
    return {
      section: 1,
      sectionComponents: [
        'ProfilePictureCoverPhoto',
        'BusinessName',
        'BusinessPhone',
        'BusinessAddress',
        'WebsiteUri',
        'LocationCategories',
        'OpeningTimes',
        'LocationDescription',
      ],
    }
  },
  computed: {
    ...mapGetters('businessProfile', [
      'location',
      'updated',
      'locationLoading',
    ])
  },
  methods: {
    ...mapActions('businessProfile', [
      'saveLocationChanges',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.save_btn {
  display: flex;
  justify-content: center;
}
</style>
